export * from './ContentfulLandingPagesService';
